module.exports = __webpack_public_path__ + "static/hand-phone-a5b2c966067332710f73b7344cd2504d.png";